import React from "react";
import { FaStar, FaStarHalfAlt } from "react-icons/fa"; // Add FaStarHalfAlt

const Testimonials = () => {
  const testimonials = [
    {
      name: "Riya",
      role: "Manager",
      text: "Working with SecurXperts felt like having our own internal security team. They explained everything clearly and fixed our issues without any confusion. We finally feel safe online.",
      image: "https://randomuser.me/api/portraits/women/44.jpg",
      rating: 4.5, 
    },
    {
      name: "Andy Dufren",
      role: "CTO of Portfolio",
      text: "We were struggling with compliance, then we approached SecurXperts they made the whole process so easy. Their team was patient, friendly and guided us step by step. Truly grateful for their support.",
      image: "https://randomuser.me/api/portraits/men/46.jpg",
      rating: 5, 
    },
    {
      name: "Pe Woodman",
      role: "CEO at Rimasu",
      text: "The SecurXperts team took the time to understand our business needs. They didn't rush anything. Their cloud security setup works perfectly for us now.",
      image: "https://randomuser.me/api/portraits/men/32.jpg",
      rating: 4.2, 
    },
  ];

  // ⭐ Star Rating Component
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    // Full stars
    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`full-${i}`} className="w-4 h-4 text-yellow-400 fill-yellow-400" />);
    }

    // Half star
    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half" className="w-4 h-4 text-yellow-400 fill-yellow-400" />);
    }

    // Empty stars
    const emptyStars = 5 - stars.length;
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<FaStar key={`empty-${i}`} className="w-4 h-4 text-yellow-200" />);
    }

    return stars;
  };

  return (
    <section className="py-10 md:py-20 bg-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/circuit-board.png')] opacity-5"></div>

      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-blue-600 font-semibold text-sm uppercase mb-2 tracking-wide">
          Client Review
        </p>
        <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-12">
          What Our Clients Says
        </h2>
        <p className="text-gray-600 max-w-2xl mx-auto">
          Trusted by businesses for delivering secure, scalable and innovative digital solutions across industries.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16">
          {testimonials.map((item, index) => (
            <div
              key={index}
              className="bg-gray-50 border border-gray-100 shadow-sm hover:shadow-lg transition-all rounded-2xl p-6 flex flex-col justify-between relative"
            >
              <p className="text-gray-700 text-base leading-relaxed mb-8">
                {item.text}
              </p>

              <div className="flex items-center gap-3 mt-auto">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-12 h-12 rounded-full object-cover border-2 border-blue-100"
                />
                <div className="text-left mt-2 min-w-0 flex-1">
                  <h4 className="font-bold text-gray-900 text-lg -mb-1 truncate">
                    {item.name}
                  </h4>
                  <p className="text-sm text-gray-500 mb-2">{item.role}</p>
                  
                  {/* ⭐ Dynamic Star Rating */}
                  <div className="flex items-center gap-0.5">
                    {renderStars(item.rating)}
                  </div>
                </div>
              </div>

              <div className="absolute bottom-0 right-0 bg-blue-900 text-white rounded-tl-3xl rounded-br-2xl p-3">
                <span className="text-4xl leading-none font-serif">"</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
